import React, { useState, useEffect, useRef } from "react";
import {
    CustomButton,
    ToastNotification,
    SkeletonLoader,
    InputTextCustomer
} from "components/shared";
import validator from 'validator'
import 'primeflex/primeflex.css';
import { UsersService } from "services/http";
import UsersInit from '../admin-page/init';
import '../admin-page/admin.css';
import { Discard } from "components/shared";

export function UserEditInfo(props) {
    const [error, setError] = useState(UsersInit.getError())
    const [data, setData] = useState(UsersInit.getData())
    const [dataSave, setDataSave] = useState()
    const [render, setRender] = useState(true)
    const [loading, setLoading] = useState(false)
    const [reset, setReset] = useState(false)
    const [affiliations, setAffiliations] = useState()
    const childRef = useRef();

    useEffect(() => {
        //  setRender(data.typeAuth !== 1)
        //_getUserAffiliations()
        _getUser()
    }, []);

    useEffect(() => {
        if (dataSave) {
            setData(dataSave)
            setLoading(false);
        }
        //
    }, [reset]);


    function _getUserAffiliations() {
        setLoading(true);
        UsersService.getUserAffiliations().then(data => {
            //  setAffiliations(data?.result);
            setLoading(false);
        }, error => {
            childRef?.current?.showToast({ type: "warn", title: "Error response", message: error, durable: true });
            setLoading(false);
        });
    }

    function _getUser() {
        setLoading(true);
        UsersService.getUser(props.username).then(data => {
            setData(data?.result);
            setDataSave(data?.result);
            setLoading(false);
            setReset(!reset)
            setRender(data.result?.typeAuth === 0)
        }, error => {
            childRef?.current?.showToast({ type: "warn", title: "Error response", message: error, durable: true });
            setLoading(false);
        });
    }

    const _validateEmail = (e) => {
        if (e.target.value.length != 0) {
            if (!validator.isEmail(e.target.value)) {
                setError(prevState => {
                    return { ...prevState, [e.target.name]: 'Enter valid Email!' }
                });
            } else {
                setError(prevState => {
                    return { ...prevState, [e.target.name]: '' }
                });
            }
        } else {
            setError(prevState => {
                return { ...prevState, [e.target.name]: '' }
            });
        }
    }
    const _validatePhone = (e) => {
        var pattern = new RegExp(/^[0-9\b]+$/);
        if (e.target.value.length != 0) {
            if (!pattern.test(e.target.value)) {
                setError(prevState => {
                    return { ...prevState, [e.target.name]: 'Please enter only number.!' }
                });

            } else {
                if (e.target.value.length != 10) {
                    setError(prevState => {
                        return { ...prevState, [e.target.name]: 'Please enter valid phone number.!' }
                    });
                } else {
                    setError(prevState => {
                        return { ...prevState, [e.target.name]: '' }
                    });
                }
            }
        } else {
            setError(prevState => {
                return { ...prevState, [e.target.name]: '' }
            });
        }
    }

    function _validateRequired(name) {
        if (data[name]?.length === 0) {
            setError(prevState => {
                return { ...prevState, [name]: 'Please fill in this field.!' }
            });
            return false;
        } else {
            setError(prevState => {
                return { ...prevState, [name]: '' }
            });
            return true;
        }
    }

    function _validateError() {
        if (error.phoneNumber1
            || error.phoneNumber2
            || error.email) {
            return false;
        } else {
            return true;
        }
    }

    function _handleChange(e) {
        data[e.target.name] = e.target.value;
        e.preventDefault();
    }

    function _handleChangeMap(name, value) {
        //console.log("change object item ->"+name+" ->"+value)
        setData(prevState => {
            return { ...prevState, [name]: value }
        });
    }

    function _reset() {
        setLoading(true);
        setReset(!reset)
    }

    function _submit(e) {
        e.preventDefault();
        const _valid = _validateError();
        if (_valid) {
            setLoading(true);
            UsersService.submitUserUpdate(data).then(data => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "success",
                    title: "Success response",
                    message: data.message,
                    durable: false
                });
            }, error => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "warn",
                    title: "Error response",
                    message: error, durable: false
                });
            });
        }
    }

    const FieldContainer = (props) => {
        return <div className="mx-2 mt-1 mb-3 d-flex">{props.children}</div>
    }

    return (
        <div style={{ width: "350px" }}>
            {loading ? <SkeletonLoader factor={8} rectangle /> :
                <form onSubmit={_submit}>
                    <div className="d-grid" >
                        <FieldContainer>
                            <InputTextCustomer id="username" name='username'
                                onChange={_handleChange}
                                type="text" label='Username'
                                required={true}
                                disabled={true}
                                value={data.username} />
                        </FieldContainer>

                        <FieldContainer>
                            <InputTextCustomer id="email" name='email'
                                onChange={_handleChange}
                                type="text" label='Email'
                                disabled={!render}
                                onBlur={_validateEmail}
                                validate={error?.email}
                                value={data.email} />
                        </FieldContainer>

                        <FieldContainer>
                            <InputTextCustomer id="firstName" name='firstName'
                                onChange={_handleChange}
                                type="text" label='Firstname'
                                disabled={!render}
                                value={data.firstName} />
                        </FieldContainer>

                        <FieldContainer>
                            <InputTextCustomer id="lastName" name='lastName'
                                onChange={_handleChange}
                                type="text" label='Lastname'
                                disabled={!render}
                                value={data.lastName} />
                        </FieldContainer>

                        <FieldContainer>
                            <InputTextCustomer id="phoneNumber1" name='phoneNumber1'
                                onChange={_handleChange}
                                type="text" label='Phone Number1 '
                                disabled={!render}
                                onBlur={_validatePhone}
                                validate={error?.phoneNumber1}
                                value={data.phoneNumber1} />
                        </FieldContainer>

                        <FieldContainer>
                            <InputTextCustomer id="phoneNumber2" name='phoneNumber2'
                                onChange={_handleChange}
                                type="text" label='Phone Number2 '
                                onBlur={_validatePhone}
                                validate={error?.phoneNumber2}
                                value={data.phoneNumber2} />
                        </FieldContainer>

                        <FieldContainer>
                            <div style={{ width: "50%" }}>
                                <Discard onClick={_reset} style={{ width: "100%" }} />
                            </div>
                            &nbsp;
                            <div style={{ width: "50%" }}>
                                <CustomButton
                                    label="Submit"
                                    icon="bi bi-check-circle-fill"
                                    type='Submit'
                                    style={{ width: "100%" }}
                                    className="p-button-danger btc"
                                />
                            </div>
                        </FieldContainer>
                    </div>
                </form>
            }
            <ToastNotification ref={childRef} />
        </div>
    );
}
